import React from "react";

const RiderType = ({ rider }) => {
  const riderType = rider.rider_type || rider.riderType;
  return riderType === "aide" ? <sup>&nbsp;A</sup> : null;
};

export default RiderType;
